
export default {}
export const IDENTIFICACIONPIN_DOMAIN = 'socio.fernheim.com.py'
export const API_URL = '/api'
export const API_TIMEOUT = 30 * 1000 // 30 seconds timeout

export const COOKIE_NAME = 'id_sesion_pin'
export const COOKIE_DOMAIN = '.fernheim.com.py'
export const COOKIE_SECURE = true

export const IDENTIFICACION_COOKIE_NAME = 'id_sesion'

export const CONSULTACAP_URL = 'https://cuentas.fernheim.com.py'
export const CONSULTACAP_NOMBRE = 'Consulta de Cuentas'
